import {useHistory} from "react-router-dom";
import {useEffect, useState} from "react";
import {t} from "i18next";
import {Table, Tooltip, Typography} from "antd";
import CashRegisterSummary from "./CashRegisterSummary";
import DataGrid from "../../core/components/data-grid/DataGrid";
import Helper from "../../core/Helper";
import ApiService from "../../core/service/ApiService";
import {useDataGrid} from "../../core/components/data-grid/DataGridContext";
import {useModal} from "../../core/context/ModalContext";

const SummaryRow = () => {
    const {queryModel} = useDataGrid();
    const {openModal, closeModal} = useModal();
    const [summary, setSummary] = useState({
        totalSummary: [], methodSummaries: []
    });

    const openPaymentSummaryByMethod = (data) => {
        openModal(t('Summary'), (
            <CashRegisterSummary
                data={summary.methodSummaries}
            />
        ))
    }

    const load = async () => {
        const res2 = await ApiService.CashView.GetSummary({
            ...queryModel.filter,
            startDate: Helper.Date.beginOfDay(queryModel.filter.startDate),
            endDate: Helper.Date.endOfDay(queryModel.filter.endDate),
        });
        if(res2.success)
        {
            setSummary(res2.data)
        }
    }

    useEffect(() => {
        load()
    }, [queryModel.updateKey])

    return (
        <Table.Summary>
            <Table.Summary.Row>
                <Table.Summary.Cell colSpan={3}>
                    <Typography.Text strong={true}>
                        {t('Total')}
                    </Typography.Text>
                </Table.Summary.Cell>
                <Table.Summary.Cell colSpan={7}>
                    <Typography.Text strong={true}>
                        <a onClick={openPaymentSummaryByMethod} style={{fontWeight: 'bold'}}>
                            <table>
                                {
                                    summary?.totalSummary?.map(s => {
                                        return (
                                            <tr>
                                                <td>
                                                    {Helper.Currency.format(s.total, {currency: s.currency || 'TRY'})}
                                                </td>
                                            </tr>
                                        )
                                    })
                                }
                            </table>
                        </a>
                    </Typography.Text>
                </Table.Summary.Cell>
            </Table.Summary.Row>
        </Table.Summary>
    )
}

export default function CashRegisterGrid()
{
    const history = useHistory();
    const {setData, setPaginationResult, queryModel, setDataGridProps, refreshDataGrid} = useDataGrid();

    const load = async () => {
        const res = await ApiService.CashView.GetDataGrid({
            ...queryModel,
            filter: {
                ...queryModel.filter,
                startDate: Helper.Date.beginOfDay(queryModel.filter.startDate),
                endDate: Helper.Date.endOfDay(queryModel.filter.endDate),
            }
        })
        if(res.success)
        {
            setData(res.data)
            setPaginationResult(res.pagination)
        }
    }

    useEffect(() => {
        load()
    }, [queryModel.updateKey])

    useEffect(() => {
        setDataGridProps({
            rowKey: 'id',
            columns: [
                {key: 'type', dataIndex: 'type', title: t('Type'), render: (text, row) => text === 1 ? t('Revenues') : t('Expense')},
                {key: 'date', dataIndex: 'createdDate', title: t('Date'), render: (text, row) => Helper.Date.dateFormat(text), sorter: true},
                {key: 'description', dataIndex: 'description', title: t('Description'), render: (text, row) => text ? text : '-'},
                {key: 'amount', dataIndex: 'amount', sorter: true, title: t('Revenues')+'/'+t('Expense'), render: (text, row) => Helper.Currency.format(text, {currency: row?.currency})},
                {key: 'paymentMethodName', dataIndex: 'paymentMethodName', sorter: true, title: t('Method')},
                {key: 'appointmentId', dataIndex: 'appointmentId', title: t('Id')},
                {key: 'patientCustomId', dataIndex: 'patientCustomId', title: t('Patient Id')},
                {key: 'patientName', dataIndex: 'patientName', title: t('Name'), render: (text, row) => text ? <a href={`/app/patients/${row?.patientId}/appointments/${row.appointmentId}`} target={'_blank'}>{`${row.patientName} ${row.patientLastname}`}</a> : '-'},
                {key: 'appointmentStartDate', dataIndex: 'appointmentStartDate', sorter: true, title: t('Appointment Date'), render: (text, row) => Helper.Date.dateFormat(text)},
                {key: 'unitName', dataIndex: 'unitName', columnName: 'unitName', sorter: true, title: t('Unit')},
                // {key: 'doctorName', dataIndex: 'doctorName', columnName: 'doctorName', sorter: true, title: t('Doctor')},
                {key: 'institutionName', dataIndex: 'institutionName', columnName: 'institutionName', sorter: true, title: t('Institution')},
                { key: 'appointmentTypeName', dataIndex: 'appointmentTypeName', columnName: 'appointmentType.name', sorter: true, title: t('Appointment Type') },
                {key: 'cashRegisterName', dataIndex: 'cashRegisterName', columnName: 'cashRegisterName', sorter: true, title: t('Cash Register')},
                // {key: 'appointmentTotalPrice', dataIndex: 'appointmentTotalPrice', sorter: true, title: t('Operation Price'), render: (text, row) => CurrencyFormat(text)},
                // {key: 'appointmentTotalPaid', dataIndex: 'appointmentTotalPaid', sorter: true, title: t('Paid'), render: (text, row) => CurrencyFormat(text)},
            ],
            antdTableProps: {
                summary: () => (
                    <SummaryRow />
                )
            }
        })
    }, [])

    return (
        <>
            <DataGrid />
        </>
    )
}
